import { render, staticRenderFns } from "./InvasiveServiceInfo.vue?vue&type=template&id=1141f8f9&"
import script from "./InvasiveServiceInfo.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InvasiveServiceInfo.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1141f8f9')) {
      api.createRecord('1141f8f9', component.options)
    } else {
      api.reload('1141f8f9', component.options)
    }
    module.hot.accept("./InvasiveServiceInfo.vue?vue&type=template&id=1141f8f9&", function () {
      api.rerender('1141f8f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InvasiveServiceInfo/InvasiveServiceInfo.vue"
export default component.exports